import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import { COUNT_CURRENT_EVENT_UPDATED } from '../query/event'

class EventNumberComponent extends React.Component {
  render () {
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='TOUS LES EVENEMENTS'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <span style={styles.number}>{this.props.refuelEvents.length}</span>
          </div>
          <div style={styles.labelContent}>
            <span style={styles.label}>Depuis minuit</span>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '98px'
  },
  number: {
    fontSize: '70px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  labelContent: {
    textAlign: 'center',
    marginTop: '100px',
    width: '100%',
    height: '28px'
  },
  label: {
    fontSize: '16px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  }
}

export default EventNumberComponent
